import { makeStyles } from '@material-ui/core';
import { em, vh } from 'src/common/helpers/dimension-helper';
import { themeColor } from 'src/mui-theme';

// Until the theme gets typed...
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const styles = makeStyles((theme: any) => ({
  main: {
    fontSize: em(16),
    marginTop: '10vh',
    width: '100%',
    height: '90vh',
    outline: 0,
    padding: '0 1vw 2.34vh 1vw',
  },
  topArea: {
    height: '10.4vh',
  },
  productLabel: {
    fontFamily: '"Roboto", Helvetica, Arial, sans-serif',
    fontWeight: 500,
    fontStretch: 'normal',
    fontStyle: 'normal',
    letterSpacing: '1px',
    color: themeColor.defaultTextColor,
    paddingTop: '1.5vh',
    fontSize: vh(3.306),
  },
  displayButtons: {
    paddingTop: '2.34vh',
  },
  allItemsMiddleArea: {
    display: 'flex',
    flexGrow: 1,
    overflowY: 'hidden',
  },
  productDivider: {
    backgroundColor: theme?.configColors?.secondaryColor || theme.palette.secondary.main,
    width: '4.9vw',
    height: '0.7vh',
    marginTop: '0.7vh',
  },
  background: {
    backgroundColor: themeColor.lightBackground,
  },

  allItemsWrapper: {
    flexWrap: 'nowrap',
    flexGrow: 1,
  },
}));
